import {
  BookOpen,
  NotebookPen,
  Play,
  ShieldCheck,
  Sparkles,
  Triangle
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type Station = {
  code: string;
  label: string;
  summary: string;
  icon: LucideIcon;
};

export const stations: Station[] = [
  {
    code: "prism",
    label: "PRISM",
    summary: "پروفایل رفتاری، الگوهای فشار و اولین نقشه رشد شخصی.",
    icon: Triangle
  },
  {
    code: "academy",
    label: "آکادمی",
    summary: "مسیر یادگیری فارسی از ریاضی تصمیم تا مدیریت ریسک.",
    icon: BookOpen
  },
  {
    code: "journal",
    label: "ژورنال",
    summary: "ثبت شواهد، احساسات، یادداشت‌ها و نظم مرور معاملات.",
    icon: NotebookPen
  },
  {
    code: "replay",
    label: "ری‌پلی",
    summary: "تمرین تصمیم‌ها در زمینه واقعی قبل از تکرار اشتباه در لایو.",
    icon: Play
  },
  {
    code: "war-room",
    label: "WAR ROOM",
    summary: "مرز دسترسی پیشرفته برای ابزارهای اجرای کنترل‌شده.",
    icon: ShieldCheck
  }
];

export const foundationItems = [
  {
    title: "Cloudflare Pages",
    body: "سایت عمومی فارسی، مسیرهای سئو و تحویل سریع فایل‌های استاتیک."
  },
  {
    title: "Cloudflare Workers",
    body: "API مستر رن، مرز امتیازدهی PRISM، نقشه رشد و endpointهای حساب."
  },
  {
    title: "Supabase",
    body: "احراز هویت، Postgres، RLS و داده‌های PRISM و ژورنال متعلق به کاربر."
  },
  {
    title: "Hermes Safety",
    body: "کوچ آموزشی فقط برای رشد؛ بدون قطعیت سیگنال و بدون وعده سود."
  }
];

export const HermesIcon = Sparkles;
